<template>
  <section class="sales-and-accounts">
    <!-- Sales Overview -->
    <div class="chart-card">
      <h1>Sales Overview</h1>
      <div class="divider"></div>

      <div class="stats-row">
        <div v-for="(item, index) in salesData" :key="index" class="stat-item">
          <p class="stat-title">{{ item.label }}</p>
          <p class="stat-value">{{ item.value }}</p>
          <p class="stat-change" :class="{ down: item.isDown }">
            <i :class="item.isDown ? 'fa-solid fa-arrow-down' : 'fa-solid fa-arrow-up'"></i>
            {{ item.change }}
          </p>
        </div>
      </div>

      <SalesChart />
    </div>

    <!-- Account Retention -->
    <div class="chart-card">
      <h1>Account Retention</h1>
      <div class="divider"></div>

      <div class="retention-stats">
        <div class="retention-item expansion">
          <p class="amount">Ksh 50,456.6</p>
          <p class="status">EXPANSION</p>
          <p class="desc">
            <i class="fa-solid fa-arrow-up"></i> Customers who have subscribed
          </p>
        </div>

        <div class="retention-item cancellation">
          <p class="amount">Ksh 10,456.6</p>
          <p class="status">CANCELLATION</p>
          <p class="desc">
            <i class="fa-solid fa-arrow-down"></i> Customers who have unsubscribed
          </p>
        </div>
      </div>

      <AccountStatusChart />
    </div>
  </section>
</template>

<script>
import SalesChart from "../../components/adminpage/others/salesgrowthchart.vue";
import AccountStatusChart from "../../components/adminpage/others/accountstatuschart.vue";

export default {
  name: "SalesData",
  components: { SalesChart, AccountStatusChart },
  data() {
    return {
      salesData: [
        { label: "Users", value: "1.1K", change: "12.37%", isDown: false },
        { label: "Traffic", value: "14.2K", change: "10.37%", isDown: false },
        { label: "Store", value: "3.1K", change: "3.37%", isDown: true },
        { label: "Online", value: "0.1K", change: "12.37%", isDown: true },
      ],
    };
  },
};
</script>

<style scoped>
/* ===== Layout ===== */
.sales-and-accounts {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  background-color: var(--background-color1);
  padding: 1rem;
  box-sizing: border-box;
}

.chart-card {
  flex: 1 1 48%;
  background-color: var(--background-color2);
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 0 6px var(--border-color-hover1);
  min-width: 300px;
}

/* ===== Titles ===== */
h1 {
  font-size: 0.9rem;
  color: var(--text-color2);
  margin-bottom: 0.4rem;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: rgb(200, 200, 200);
  margin: 0.5rem 0 1rem;
}

/* ===== Stats Row (Sales Overview) ===== */
.stats-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.stat-item {
  text-align: center;
  flex: 1 1 100px;
  margin-bottom: 0.8rem;
}

.stat-title {
  font-size: 0.65rem;
  color: var(--text-color2);
}

.stat-value {
  font-size: 0.9rem;
  color: var(--text-color1);
  font-weight: 600;
}

.stat-change {
  font-size: 0.6rem;
  color: #4caf50;
}

.stat-change.down {
  color: #e74c3c;
}

/* ===== Account Retention ===== */
.retention-stats {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.retention-item {
  flex: 1 1 48%;
  text-align: center;
}

.amount {
  font-size: 0.9rem;
  color: var(--text-color1);
  font-weight: 600;
}

.status {
  font-size: 0.7rem;
  letter-spacing: 0.5px;
}

.desc {
  font-size: 0.65rem;
  color: var(--text-color2);
}

.expansion .status {
  color: #42a5f5;
}

.cancellation .status {
  color: #ef5350;
}

/* ===== Responsive ===== */
@media (max-width: 940px) {
  .sales-and-accounts {
    flex-direction: column;
  }

  .chart-card {
    width: 100%;
  }

  .stats-row {
    justify-content: space-evenly;
  }
}
</style>
